export const labelSizes = {
    sm: {
        value: 'sm',
        label: 'Small'
    },
    md: {
        value: 'md',
        label: 'Medium'
    },
    lg: {
        value: 'lg',
        label: 'Large'
    }
};

export const widths = {
    "100": {
        value: 12,
        label: '100%'
    },
    "75": {
        value: 9,
        label: '75%'
    },
    "50": {
        value: 6,
        label: '50%'
    },
    "25": {
        value: 3,
        label: '25%'
    }
};

